import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import config from "../config.js";
const API_URL = config['api_url'];

const Feedback = () => {
  const { token } = useParams();
  const [comment, setComment] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [initialComment, setInitialComment] = useState('');
  const [submitted, setSubmitted] = useState(false); // NEW
  const [file, setFile] = useState(null); 
  const [submittedAt, setSubmittedAt] = useState(null);

  // On load, check if feedback was already submitted
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await axios.get(`${API_URL}/feedback-status/${token}`);
        if (response.data.status !== 'pending') {
          setAlreadySubmitted(true);
          setInitialComment(response.data.comment);
          setSubmittedAt(response.data.submitted_at);
        }
      } catch (error) {
        setStatusMessage('Invalid or expired feedback link.');
        setAlreadySubmitted(true); // Hide form on invalid
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [token]);

  // const handleSubmit = async (status) => {
  //   setLoading(true);
  //   const formData = new FormData();
  //   formData.append('token', token);
  //   formData.append('comment', comment);
  //   formData.append('status', status);
  //   if (file) {
  //     formData.append('file', file);
  //   }
  //   try {
  //     const response = await axios.post(`${API_URL}/submit-feedback`,formData,{
  //       token,
  //       comment,
  //       status
  //     });

  //     if (response.status === 200) {
  //       setStatusMessage(response.data.message); // e.g. "Feedback approved successfully."
  //       setSubmitted(true); // User just submitted now
  //     }
  //   } catch (error) {
  //     setStatusMessage('Submission failed. Try again later.');
  //   }
  //   setLoading(false);
  // };

  const handleSubmit = async (status) => {
  if (!comment.trim()) {
    setStatusMessage('Please enter your feedback before submitting.');
    return;
  }

  setLoading(true);
  const formData = new FormData();
  formData.append('token', token);
  formData.append('comment', comment);
  formData.append('status', status);
  if (file) {
    formData.append('file', file);
  }

  try {
    const response = await axios.post(`${API_URL}/submit-feedback`, formData);

    if (response.status === 200) {
      setStatusMessage(response.data.message);
      setSubmitted(true);
    }
  } catch (error) {
    setStatusMessage('Submission failed. Try again later.');
  }
  setLoading(false);
};


  if (loading) return <p>Loading...</p>;

  // 🟢 Show "successfully submitted" message if just submitted
  if (submitted) {
    return (
      <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
        <h2>Feedback Submitted Successfully ✅</h2>
        <p><strong>Your comment:</strong> {comment}</p>
        <p>Thank you for your response.</p>
      </div>
    );
  }

  // 🔁 Show already submitted message on second+ visits
  if (alreadySubmitted) {
    return (
      <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
        <h2>Feedback Already Submitted</h2>
        <p><strong>Status:</strong> Already submitted</p>
        {initialComment && (
          <p><strong>Your comment:</strong> {initialComment}</p>
        )}
        {submittedAt && (
        <p><strong>Submitted on:</strong> {new Date(submittedAt).toLocaleString()}</p>
      )}
      </div>
    );
  }

  // ✍️ Show feedback form if not submitted
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h2>Feedback Approval</h2>
      <p>Please provide your comments and choose an action below.</p>

      <textarea
        rows="6"
        cols="60"
        placeholder="Enter your feedback..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        style={{ padding: '10px', fontSize: '14px', marginBottom: '1rem' }}
      ></textarea>
      <br />
      <h3>Attachments --  (SBFs Revision/Exceptional approvals etc)</h3>
        <input
        type="file"
        onChange={(e) => setFile(e.target.files[0])}
        accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
        style={{ marginBottom: '1rem' }}
      />
      <br />

      <button
        onClick={() => handleSubmit('approved')}
        disabled={loading}
        style={{ marginRight: '10px', padding: '10px 20px', backgroundColor: 'green', color: 'white',cursor:'pointer' }}
      >
        Approve
      </button>
      <button
        onClick={() => handleSubmit('rejected')}
        disabled={loading}
        style={{ padding: '10px 20px', backgroundColor: 'red', color: 'white',cursor:'pointer' }}
      >
        Reject
      </button>

      {statusMessage && (
        <p style={{ marginTop: '20px', fontWeight: 'bold' }}>{statusMessage}</p>
      )}
    </div>
  );
};

export default Feedback;







